<script
    setup
    lang="ts"
>
import AppPlaceholder from "@/components/UI/AppPlaceholder/AppPlaceholder.vue";
</script>

<template>
  <div class="custom-assessment__preloader">
    <div class="custom-assessment__header">
      <app-placeholder
          width="36px"
          height="36px"
          border-radius="100%"
      />
      <app-placeholder
          width="30%"
          height="24px"
      />
      <app-placeholder
          width="36px"
          height="36px"
          border-radius="100%"
      />
    </div>
    <div class="custom-assessment__container">
      <div class="custom-assessment__sidebar">
        <div class="custom-assessment__details">
          <div
              class="custom-assessment__details__item"
              v-for="item in 4"
              :key="item"
          >
            <app-placeholder
                height="15px"
                width="110px"
            />
            <app-placeholder
                height="15px"
                width="55px"
            />
          </div>
        </div>
        <div class="custom-assessment__description">
          <h5 class="custom-assessment__sidebar__label">Описание</h5>
          <app-placeholder height="15px" />
        </div>
        <div class="custom-assessment__files">
          <h5 class="custom-assessment__sidebar__label">Прикреплённые файлы</h5>
          <app-placeholder height="35px" />
          <app-placeholder
              height="35px"
              margin-top="5px"
          />
        </div>
        <div class="custom-assessment__files">
          <h5 class="custom-assessment__sidebar__label">Файлы из чата</h5>
          <app-placeholder height="54px" />
        </div>
      </div>
      <div class="custom-assessment__main">
        <div class="d-flex">
          <app-placeholder
              width="50%"
              height="37px"
          />
          <app-placeholder
              width="50%"
              height="37px"
          />
        </div>

        <div class="custom-assessment__tabs__item">
          <app-placeholder
              v-for="i in 5"
              :key="i"
              width="100%"
              margin-bottom="5px"
          />
        </div>
      </div>
    </div>
  </div>
</template>